import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AnnouncementBar from "./components/AnnouncementBar";
import MarketingPopup from "./components/MarketingPopup";

import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import Tests from "./pages/Tests";
import TestDetail from "./pages/TestDetail";
import TakeTest from "./pages/TakeTest";
import TestResult from "./pages/TestResult";
import TestShare from "./pages/TestShare";
import Redeem from "./pages/Redeem";
import Subscriptions from "./pages/Subscriptions";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Testimonials from "./pages/Testimonials";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";

import "./App.css";

const ProtectedRoute = ({ children, adminOnly }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#6B4BA3]">Memuat…</div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

function Shell() {
  const location = useLocation();
  const hideChrome = location.pathname.startsWith("/admin");
  return (
    <div className="min-h-screen flex flex-col">
      {!hideChrome && <AnnouncementBar />}
      {!hideChrome && <Navbar />}
      {!hideChrome && <MarketingPopup />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:slug" element={<EventDetail />} />
          <Route path="/tests" element={<Tests />} />
          <Route path="/tests/:slug" element={<TestDetail />} />
          <Route path="/tests/:slug/take" element={<ProtectedRoute><TakeTest /></ProtectedRoute>} />
          <Route path="/test-results/:id" element={<ProtectedRoute><TestResult /></ProtectedRoute>} />
          <Route path="/share/test/:shareId" element={<TestShare />} />
          <Route path="/redeem" element={<ProtectedRoute><Redeem /></ProtectedRoute>} />
          <Route path="/subscriptions" element={<Subscriptions />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
          <Route path="/order/:id" element={<ProtectedRoute><OrderSuccess /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/admin/*" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        </Routes>
      </main>
      {!hideChrome && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Toaster position="top-right" richColors />
          <Shell />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
